import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import styled from 'styled-components';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { ACStep } from './ACStep';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StepContainer = styled.div.withConfig({
  displayName: "ACVerticalStepper__StepContainer",
  componentId: "h4ieag-0"
})(({
  $spaceCssStyles
}) => Object.assign({}, $spaceCssStyles));
const ACVerticalStepper = ({
  steps,
  activeStep,
  iconOffset = '100',
  renderStep,
  stepSpacing = {}
}) => {
  const spaceCssStyles = useMapTokenPropsToCSS(stepSpacing);
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "vertical-stepper",
    children: steps.map((step, index) =>
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StepContainer, {
      $spaceCssStyles: spaceCssStyles,
      children: /*#__PURE__*/_jsxs(Flex, {
        "data-test-id": "vertical-stepper-step",
        children: [/*#__PURE__*/_jsx(ACStep, {
          completed: !!step.complete,
          connectorActive: index < activeStep,
          iconActive: index === activeStep,
          iconOffset: iconOffset,
          showConnector: index < steps.length - 1
        }), /*#__PURE__*/_jsx(Spacer, {
          marginInlineEnd: "200"
        }), /*#__PURE__*/_jsx(Box, {
          children: renderStep(step)
        })]
      })
    }, index))
  });
};
export default ACVerticalStepper;